export default __webpack_public_path__ + "static/media/FoodChainGrassland_01.00daef56.png";